import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { ExportData } from "./ExportData";
import { selectProjects } from "../reducers/projectSlice";
import { NewWell } from "./NewWell";

import WellList from "./WellList";

const useStyles = makeStyles(theme => ({
  empty: {
    height: 'auto',
    width: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 200
  }
}));

const WellLists = ({ projectId, lists, listIds, wells }) => {
  const classes = useStyles();
  const projects = useSelector(selectProjects);

  const [newWellVisible, setNewWellVisible] = useState(false);
  const [exportDataVisible, setExportDataVisible] = useState(false);

  return (
    <>
      {exportDataVisible && <ExportData projectName={projects.byId[projectId]?.name} handleExportDataClose={handleExportDataClose} />}
      {newWellVisible && <NewWell 
        newWellClose={handleNewWellClose} 
        listId={lists.currentListId} 
      />}

      {listIds.length === 0 && (
        <div className={classes.empty}>
          <Typography style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%'}}>
            <Typography variant='body' color="textSecondary">
              Create a new list to get started
            </Typography>
          </Typography>
        </div>
      )}
      {listIds.map(listId => {
        return (
          <WellList 
            projectId={projectId} 
            listId={listId} 
            setNewWellVisible={setNewWellVisible} 
            setExportDataVisible={setExportDataVisible} 
            key={listId}
          /> 
        )
      })}
    </>
  )

  // FUNCTIONS
  function handleNewWellClose(e) {
    setNewWellVisible(false);
  };

  function handleExportDataClose() {
    setExportDataVisible(false);
  };

};

export default React.memo(WellLists);